import {LocalPlayerContext} from '../offline/LocalPlayerContext';
import React, {useEffect, useState, useContext} from 'react';
import CoinIcon from './CoinIcon';
import {accountHeaders} from '../utils/accountFetch';
import {getApiUrl} from '../config/serverEndpoint';

// Account-scoped and server-authoritative. Never present an unknown balance as zero.
export default function HomeCoinBalance({username, localOnly=false, onOpen}) {
  const local=useContext(LocalPlayerContext);
  const snapshot=local?.previewSnapshot&&local?.coinOwner===username&&Number.isSafeInteger(local?.coinBalance)&&local.coinBalance>=0?{username,enabled:true,balance:local.coinBalance}:null;
  const [record,setRecord]=useState(snapshot);
  const [fresh,setFresh]=useState(Boolean(snapshot));
  useEffect(()=>{
    let alive=true, controller;
    setRecord(null);setFresh(false);
    const refresh=async()=>{
      if(localOnly||!username||navigator.onLine===false){setFresh(false);return;}
      controller?.abort();controller=new AbortController();const current=controller;
      const timeout=setTimeout(()=>current.abort(),8000);
      try{
        const r=await fetch(getApiUrl(`/coins?username=${encodeURIComponent(username)}`),{headers:accountHeaders(),cache:'no-store',signal:current.signal});
        const data=await r.json();
        if(!r.ok)throw Error('Balance unavailable');
        if(alive&&!current.signal.aborted){setRecord({username,enabled:data.enabled,balance:Number.isSafeInteger(data.balance)&&data.balance>=0?data.balance:null});setFresh(true);}
      }catch(_){if(alive&&controller===current)setFresh(false);}finally{clearTimeout(timeout);}
    };
    const offline=()=>{controller?.abort();setFresh(false);};
    const changed=e=>{if(e.detail?.username?.toLowerCase()===username?.toLowerCase())refresh();};
    refresh();window.addEventListener('online',refresh);window.addEventListener('focus',refresh);window.addEventListener('offline',offline);window.addEventListener('kelimo-coins-updated',changed);
    return()=>{alive=false;controller?.abort();window.removeEventListener('online',refresh);window.removeEventListener('focus',refresh);window.removeEventListener('offline',offline);window.removeEventListener('kelimo-coins-updated',changed);};
  },[username,localOnly]);
  const value=record?.username===username?record:null;
  if(value?.enabled===false)return null;
  const amount=value?.balance;
  return <button type="button" className="home-coins-r17" onClick={onOpen} aria-label={`Kelimo Coin: ${amount==null?'bakiye bilinmiyor':amount+' KC'}${!fresh&&amount!=null?', son doğrulanan bakiye':''}. Marketi aç`} title={!fresh?'Güncel bakiye için bağlantı gerekir':'Marketi aç'}><CoinIcon size={24}/><span><b>{amount==null?'—':amount.toLocaleString('tr-TR')} <small>KC</small></b>{!fresh&&amount!=null&&<small>Son bakiye</small>}</span></button>;
}
